export default ({ store, redirect, route }) => {
  // if (!store.state.member.auth.token) {
  //  return redirect('/beranda')
  // } else {
  //     if (route.path === '/') {
  //         return redirect('/beranda')
  //     }
  // }
}